/**
 * Opens the profile stats modal (popup) when clicked. Use for individual player names across the app.
 */

import React from 'react';
import { useStatsModal } from '../contexts/StatsModalContext';

export default function ProfileLink({ userId, children, className }) {
  const { openProfileModal } = useStatsModal();
  if (!userId) return <>{children}</>;
  return (
    <button
      type="button"
      onClick={() => openProfileModal(userId)}
      className={className || 'profile-link'}
    >
      {children}
    </button>
  );
}
